import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar", "label"]
  static values = {
    thresholds: Object,
    section: String,
  }

  connect() {
    this._currentPercentage = 0

    this.updateProgress()

    this._observer = new MutationObserver(() => {
      this.updateProgress()
    })

    this._observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ["data-filled"],
    })
  }

  disconnect() {
    if (this._observer) this._observer.disconnect()
    if (this._timer) clearInterval(this._timer)
  }

  updateProgress() {
    let fields

    if (this.hasSectionValue) {
      const section = document.querySelector(
        `#${this.sectionValue}-info-details`
      )
      if (!section) return
      fields = section.querySelectorAll("[data-filled]")
    } else {
      fields = document.querySelectorAll("[data-filled]")
    }

    if (!fields.length) return

    let filled = 0
    fields.forEach((f) => {
      if (f.dataset.filled === "true") filled++
    })

    const percentage = Math.round((filled / fields.length) * 100)

    if (percentage === this._currentPercentage) return

    this.animateTo(percentage)
    this._currentPercentage = percentage
  }

  animateTo(target) {
    if (this._timer) clearInterval(this._timer)

    const duration = 600
    const stepTime = 16
    const steps = duration / stepTime
    const start = this._currentPercentage
    const increment = (target - start) / steps

    this.setColor(target)

    let current = start

    this._timer = setInterval(() => {
      current += increment

      const done =
        (increment >= 0 && current >= target) ||
        (increment < 0 && current <= target)

      if (done) {
        current = target
        clearInterval(this._timer)
      }

      this.element.style.setProperty("--percentage", current)

      this.barTargets.forEach((bar) => {
        bar.style.width = `${current}%`
        bar.setAttribute("aria-valuenow", Math.round(current))
      })

      if (this.hasLabelTarget) {
        this.labelTarget.textContent = `${Math.round(current)}%`
      }
    }, stepTime)
  }

  setColor(value) {
    this.barTargets.forEach((bar) => {
      bar.classList.remove("bg-primary", "bg-warning", "bg-success")

      if (value <= this.thresholdsValue.primary) {
        bar.classList.add("bg-primary")
      } else if (value <= this.thresholdsValue.warning) {
        bar.classList.add("bg-warning")
      } else {
        bar.classList.add("bg-success")
      }
    })
  }
}
